// extracted by mini-css-extract-plugin
export default {"default":"default--EA7lp","custom":"custom--O8FMx","underline":"underline--Hhu3F","disabled":"disabled--GbdDa"};